import React from 'react'
import { Typography, Button } from '@lightbeamai/design-system'
import './emptyState.less'
import { ArrowSquareOut as IconArrowSquareOut } from 'phosphor-react'
import { Link } from 'react-router-dom'

interface EmptyStateProps {
  title?: string
  description?: string
  icon?: React.ReactNode
  fallbackRedirectionButton?: {
    text: string
    url: string
  }
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  fallbackRedirectionButton
}) => {
  return (
    <div className="pci-widgets-empty-state">
      <div>{icon}</div>
      <div className="empty-state-text">
        {title && (
          <Typography variant="base" as="div" type="medium">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="baseMinus2" as="div">
            {description}
          </Typography>
        )}
      </div>
      {fallbackRedirectionButton && (
        <Link to={fallbackRedirectionButton.url}>
          <Button
            variant="link"
            iconPosition="right"
            icon={<IconArrowSquareOut size="16" color="var(--color-primary-light)" weight="bold" />}
            className="fallback-btn"
          >
            {fallbackRedirectionButton.text}
          </Button>
        </Link>
      )}
    </div>
  )
}
